import * as React from "react";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import usePluginEntities from "hooks/usePluginEntities";
import { Select } from "components/common";
import { Input } from "components/bootstrap";
import { useFetchDataAdapterTypes } from "components/lookup-tables/hooks/useLookupTablesAPI";
function AdapterTypeSelect({ adapterConfigType, onAdapterChange }) {
  const { t } = useTranslation("lookup_tables");
  const { types, fetchingDataAdapterTypes } = useFetchDataAdapterTypes();
  const plugins = usePluginEntities("lookupTableAdapters");
  const adapterPlugins = Object.fromEntries(plugins.map((p) => [p.type, p]));
  const sortedAdapters = useMemo(() => {
    if (!fetchingDataAdapterTypes) {
      return Object.keys(types).map((key) => {
        const typeItem = types[key];
        if (!adapterPlugins[typeItem.type]) {
          console.error(
            `Plugin component for data adapter type ${typeItem.type} is missing - invalid or missing plugin?`
          );
          return {
            value: typeItem.type,
            disabled: true,
            label: t("adapter_form.type_missing_plugin", { type: typeItem.type })
          };
        }
        return {
          value: typeItem.type,
          label: adapterPlugins[typeItem.type].displayName
        };
      }).sort((a, b) => naturalSort(a.label.toLowerCase(), b.label.toLowerCase()));
    }
    return [];
  }, [types, fetchingDataAdapterTypes, adapterPlugins, t]);
  const handleTypeSelect = useCallback(
    (adapterType) => {
      const defaultConfig = { ...types[adapterType].default_config };
      onAdapterChange({
        id: null,
        title: "",
        name: "",
        description: "",
        config: defaultConfig
      });
    },
    [onAdapterChange, types]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "data-adapter-type-select",
      label: t("adapter_form.type_label"),
      required: true,
      help: t("adapter_form.type_help")
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: t("adapter_form.type_placeholder"),
        clearable: false,
        options: sortedAdapters,
        onChange: handleTypeSelect,
        value: adapterConfigType
      }
    )
  );
}
export default AdapterTypeSelect;
